import {browserTracingIntegration} from '@sentry/browser';
import {init} from '@sentry/react';

import {getWorkspaceFromUri} from './getWorkspaceFromUri';

export function sentryInit() {
  const {workspace} = getWorkspaceFromUri();

  init({
    dsn: process.env.SENTRY_DSN,
    tracesSampleRate: 1.0,
    debug: false,
    enabled: process.env.ENV_TYPE === 'prod',
    environment: process.env.ENV_TYPE,
    initialScope: {
      tags: {workspace},
    },
    integrations: [browserTracingIntegration()],
    release: process.env.COMMIT_HASH,
    normalizeDepth: 10,
    normalizeMaxBreadth: 10,
    ignoreErrors: [/network error/i],
  });
}
